import React from 'react';
import classNames from 'classnames';
import styles from './Button.scss';

export default function Button({
  children,
  className,
  renderAs,
  onClick,
  innerRef,
  submit,
  reset,
  loading,
  disabled,
  color,
  size,
  state,
  inverted,
  text,
  icon,
  outlined,
  transparent,
  secondary,
  chartControl,
  ...props
}) {
  let Element = renderAs || 'button';
  const otherProps = {
    type: 'button',
  };
  if (submit) {
    Element = 'button';
    otherProps.type = 'submit';
  }
  if (reset) {
    Element = 'button';
    otherProps.type = 'reset';
  }

  return (
    <Element
      ref={innerRef}
      {...props}
      {...otherProps}
      disabled={disabled}
      onClick={disabled || !onClick ? undefined : onClick}
      className={classNames(className, 'button', styles.button, {
        [`is-${color}`]: color,
        [`is-${size}`]: size,
        [`is-${state}`]: state,
        'is-inverted': inverted,
        'is-text': text,
        'is-icon': icon,
        'is-outlined': outlined,
        'is-transparent': transparent,
        'is-secondary': secondary,
        'is-loading': loading,
        'chart-control': chartControl,
      })}
    >
      {children}
    </Element>
  );
}
